import Vue from 'vue';
import Vuex from 'vuex';

import { auth } from '../store/auth.module';
import { notif } from '../store/notif.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    notif,
  }
});